// extracted by mini-css-extract-plugin
module.exports = {"promoSection":"linksPanel_promoSection__y5vVI","promoLinks":"linksPanel_promoLinks__O5_QP","promoLinkIcon":"linksPanel_promoLinkIcon__IsNmr","link":"linksPanel_link__43cIV"};